import Footer from "../components/shared/Footer";
import Toolbar from "../components/shared/Toolbar";
import {ReactComponent as NotFoundIcon} from "../assets/errorOutcome.svg";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function NotFoundPage() {

    const { state }: any = useLocation();

    return(
        <section className='flex flex-col h-screen justify-between bg-skin-bgMain m-0 relative'>
        <Toolbar shopLogo={null}/>
            <div className='flex flex-col items-center space-y-5'>
                <NotFoundIcon className="w-32 h-32 sm:mb-14 mb-5" />
                <h3 className='p-2 text-xl text-center'>
                    <Trans i18nKey={state?.error === '401' ? 'notValidAuth' : 'paymentNotFound'} />
                </h3>
                <p className="text-base text-center px-5">
                    <Trans i18nKey={'paymentNotFoundText'} />
                </p>
            </div>
        <Footer />
      </section>
    )
}